/* ════════════════════════════════════════════════════════════
   SYMH v5 — Core JS
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function init() {
    var fns = [
      initParticles, initScrollReveal, initMobileNav, initHeaderScroll,
      initRotators, initFadeWalls, initSearch, initSlideArrows,
      initStatCounters, initCollTabs, initSpotlights, initFAQ,
      initCollectionFilters, initHeroParallax, refreshWishlistUI,
      updateWishCount, initWishlistSync, trackProductView, renderRecentlyViewed, updateCartCount,
      initMegaMenu,
      // Product page variant + Add-to-Cart wiring. The inline script in
      // product.liquid sets window.__SYMH_VARIANTS but cannot call
      // initVariants directly (it runs before this file loads), so we
      // call it here once the JS is ready.
      function () { if (window.SYMH && window.SYMH.initVariants) window.SYMH.initVariants(); }
    ];
    for (var i = 0; i < fns.length; i++) {
      try { fns[i](); } catch (e) { try { console.warn('[SYMH init]', fns[i].name || i, e); } catch(_) {} }
    }
    // Safety net: ensure every .reveal element becomes visible within 2s,
    // regardless of whether the IntersectionObserver fired. Without this,
    // a JS hiccup could leave content stuck at opacity:0.
    setTimeout(function () {
      var els = document.querySelectorAll('.reveal:not(.in)');
      for (var k = 0; k < els.length; k++) els[k].classList.add('in');
    }, 2000);
  }

  function initParticles() {
    // Legacy DIV-based particle support (older Hero markup)
    var legacyContainers = document.querySelectorAll('.hero-particles');
    for (var ci = 0; ci < legacyContainers.length; ci++) {
      var c = legacyContainers[ci];
      if (c.children.length) continue;
      var color = c.dataset.color || '#00a8ff';
      for (var i = 0; i < 28; i++) {
        var p = document.createElement('div');
        p.className = 'hparticle';
        var size = Math.random() * 4 + 2;
        p.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (Math.random()*100) + '%;bottom:' + (Math.random()*20) + '%;--dur:' + (Math.random()*8+5) + 's;--del:' + (Math.random()*-14) + 's;--pcolor:' + color + ';';
        c.appendChild(p);
      }
    }
    // New CANVAS-based multi-style hero animation
    var canvases = document.querySelectorAll('[data-hero-canvas]');
    for (var i = 0; i < canvases.length; i++) {
      initHeroCanvas(canvases[i]);
    }
  }

  function initHeroCanvas(canvas) {
    if (canvas._symhInited) return;
    canvas._symhInited = true;
    var style = canvas.dataset.animationStyle || 'particles';
    if (style === 'none') return;
    var color = canvas.dataset.color || '#00a8ff';
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var W, H, dpr;
    var running = true;

    function resize() {
      dpr = window.devicePixelRatio || 1;
      var rect = canvas.getBoundingClientRect();
      W = rect.width; H = rect.height;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Honor reduced motion — render a static frame, no animation loop
      drawStatic();
      return;
    }

    var renderer = null;
    if (style === 'particles')   renderer = makeParticles(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'fireworks')   renderer = makeFireworks(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'speed-lines') renderer = makeSpeedLines(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'stars')       renderer = makeStars(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'lightning')   renderer = makeLightning(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'halftone')    renderer = makeHalftone(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'webs')        renderer = makeWebs(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'heat-vision') renderer = makeHeatVision(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'magic')       renderer = makeMagicRunes(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'cosmic')      renderer = makeCosmic(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'frost')       renderer = makeFrost(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'bats')        renderer = makeBats(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'symbiote')    renderer = makeSymbiote(ctx, color, function(){return W;}, function(){return H;});
    if (style === 'shockwave')   renderer = makeShockwave(ctx, color, function(){return W;}, function(){return H;});
    if (!renderer) return;

    function loop() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      renderer.tick();
      requestAnimationFrame(loop);
    }
    function drawStatic() {
      ctx.clearRect(0, 0, W, H);
      if (renderer && renderer.drawStatic) renderer.drawStatic();
    }
    requestAnimationFrame(loop);
  }

  // ── PARTICLES (floating dots) ──
  function makeParticles(ctx, color, getW, getH) {
    var P = [];
    function spawn() {
      var W = getW(), H = getH();
      P = [];
      var n = Math.floor((W * H) / 14000);
      n = Math.max(20, Math.min(80, n));
      for (var i = 0; i < n; i++) {
        P.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: Math.random() * 2 + 1,
          vy: -(Math.random() * 0.4 + 0.15),
          vx: (Math.random() - 0.5) * 0.2,
          a: Math.random() * 0.6 + 0.2
        });
      }
    }
    spawn();
    window.addEventListener('resize', spawn);
    return {
      tick: function() {
        var W = getW(), H = getH();
        for (var i = 0; i < P.length; i++) {
          var p = P[i];
          p.y += p.vy;
          p.x += p.vx;
          if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
          if (p.x < -10) p.x = W + 10;
          if (p.x > W + 10) p.x = -10;
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = color;
          ctx.globalAlpha = p.a;
          ctx.shadowColor = color;
          ctx.shadowBlur = 8;
          ctx.fill();
        }
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
      }
    };
  }

  // ── FIREWORKS (random bursts that explode outward) ──
  function makeFireworks(ctx, color, getW, getH) {
    var bursts = [];
    function spawnBurst() {
      var W = getW(), H = getH();
      var cx = Math.random() * W;
      var cy = Math.random() * H * 0.7;
      var hue = Math.random();
      var c = hue < 0.5 ? color : '#ff66cc';
      var n = Math.floor(Math.random() * 24 + 24);
      var particles = [];
      for (var i = 0; i < n; i++) {
        var angle = (Math.PI * 2 * i) / n + Math.random() * 0.2;
        var speed = Math.random() * 3 + 2;
        particles.push({
          x: cx, y: cy,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 1,
          color: c
        });
      }
      bursts.push(particles);
    }
    var nextBurst = 30;
    return {
      tick: function() {
        nextBurst--;
        if (nextBurst <= 0) {
          spawnBurst();
          nextBurst = Math.floor(Math.random() * 80 + 60);
        }
        for (var b = bursts.length - 1; b >= 0; b--) {
          var burst = bursts[b];
          var alive = false;
          for (var i = 0; i < burst.length; i++) {
            var p = burst[i];
            p.x += p.vx;
            p.y += p.vy;
            p.vy += 0.03;
            p.vx *= 0.99;
            p.life -= 0.012;
            if (p.life > 0) {
              alive = true;
              ctx.beginPath();
              ctx.arc(p.x, p.y, 1.8, 0, Math.PI * 2);
              ctx.fillStyle = p.color;
              ctx.globalAlpha = p.life;
              ctx.shadowColor = p.color;
              ctx.shadowBlur = 10;
              ctx.fill();
            }
          }
          if (!alive) bursts.splice(b, 1);
        }
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
      }
    };
  }

  // ── SPEED LINES (radial comic action panel) ──
  function makeSpeedLines(ctx, color, getW, getH) {
    var lines = [];
    var cx = 0, cy = 0;
    function spawn() {
      var W = getW(), H = getH();
      cx = W * 0.5; cy = H * 0.5;
    }
    spawn();
    window.addEventListener('resize', spawn);
    return {
      tick: function() {
        var W = getW(), H = getH();
        cx = W * 0.5; cy = H * 0.5;
        if (Math.random() < 0.6) {
          lines.push({
            angle: Math.random() * Math.PI * 2,
            distance: Math.random() * 60 + 100,
            length: Math.random() * 80 + 60,
            speed: Math.random() * 4 + 4,
            life: 1
          });
        }
        for (var i = lines.length - 1; i >= 0; i--) {
          var l = lines[i];
          l.distance += l.speed;
          l.life -= 0.018;
          if (l.life <= 0 || l.distance > Math.max(W, H)) {
            lines.splice(i, 1);
            continue;
          }
          var x1 = cx + Math.cos(l.angle) * l.distance;
          var y1 = cy + Math.sin(l.angle) * l.distance;
          var x2 = cx + Math.cos(l.angle) * (l.distance + l.length);
          var y2 = cy + Math.sin(l.angle) * (l.distance + l.length);
          var grad = ctx.createLinearGradient(x1, y1, x2, y2);
          grad.addColorStop(0, 'rgba(255,255,255,0)');
          grad.addColorStop(0.5, color);
          grad.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.strokeStyle = grad;
          ctx.lineWidth = 2;
          ctx.globalAlpha = l.life * 0.8;
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }
    };
  }

  // ── STARS (twinkling) ──
  function makeStars(ctx, color, getW, getH) {
    var stars = [];
    function spawn() {
      var W = getW(), H = getH();
      stars = [];
      var n = Math.floor((W * H) / 8000);
      for (var i = 0; i < n; i++) {
        stars.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: Math.random() * 1.5 + 0.3,
          phase: Math.random() * Math.PI * 2,
          speed: Math.random() * 0.04 + 0.01,
          base: Math.random() * 0.5 + 0.2
        });
      }
    }
    spawn();
    window.addEventListener('resize', spawn);
    return {
      tick: function() {
        for (var i = 0; i < stars.length; i++) {
          var s = stars[i];
          s.phase += s.speed;
          var twinkle = (Math.sin(s.phase) * 0.5 + 0.5) * 0.7 + 0.3;
          ctx.beginPath();
          ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
          ctx.fillStyle = twinkle > 0.7 ? '#fff' : color;
          ctx.globalAlpha = s.base * twinkle;
          ctx.shadowColor = color;
          ctx.shadowBlur = twinkle > 0.7 ? 8 : 4;
          ctx.fill();
          // Sparkle cross when bright
          if (twinkle > 0.8) {
            ctx.strokeStyle = '#fff';
            ctx.globalAlpha = (twinkle - 0.8) * 5;
            ctx.lineWidth = 0.5;
            ctx.beginPath();
            ctx.moveTo(s.x - s.r * 4, s.y);
            ctx.lineTo(s.x + s.r * 4, s.y);
            ctx.moveTo(s.x, s.y - s.r * 4);
            ctx.lineTo(s.x, s.y + s.r * 4);
            ctx.stroke();
          }
        }
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
      }
    };
  }

  // ── LIGHTNING (random branching bolts) ──
  function makeLightning(ctx, color, getW, getH) {
    var bolts = [];
    var nextBolt = 80;
    function spawnBolt() {
      var W = getW(), H = getH();
      var startX = Math.random() * W;
      var endY = H;
      var segs = [];
      var x = startX, y = 0;
      var stepY = H / 10;
      for (var i = 0; i < 10; i++) {
        var nx = x + (Math.random() - 0.5) * 50;
        var ny = y + stepY;
        segs.push({ x1: x, y1: y, x2: nx, y2: ny });
        // Branch chance
        if (Math.random() < 0.3 && i > 2) {
          segs.push({
            x1: nx, y1: ny,
            x2: nx + (Math.random() - 0.5) * 80,
            y2: ny + Math.random() * 60
          });
        }
        x = nx; y = ny;
      }
      bolts.push({ segs: segs, life: 1.0, flashLife: 1.0 });
    }
    return {
      tick: function() {
        nextBolt--;
        if (nextBolt <= 0) {
          spawnBolt();
          nextBolt = Math.floor(Math.random() * 200 + 100);
        }
        var W = getW(), H = getH();
        for (var b = bolts.length - 1; b >= 0; b--) {
          var bolt = bolts[b];
          // Flash background
          if (bolt.flashLife > 0) {
            ctx.fillStyle = color;
            ctx.globalAlpha = bolt.flashLife * 0.08;
            ctx.fillRect(0, 0, W, H);
            bolt.flashLife -= 0.08;
          }
          if (bolt.life > 0) {
            for (var i = 0; i < bolt.segs.length; i++) {
              var s = bolt.segs[i];
              ctx.strokeStyle = '#fff';
              ctx.globalAlpha = bolt.life;
              ctx.lineWidth = 2;
              ctx.shadowColor = color;
              ctx.shadowBlur = 16;
              ctx.beginPath();
              ctx.moveTo(s.x1, s.y1);
              ctx.lineTo(s.x2, s.y2);
              ctx.stroke();
            }
            bolt.life -= 0.04;
          } else {
            bolts.splice(b, 1);
          }
        }
        ctx.globalAlpha = 1;
        ctx.shadowBlur = 0;
      }
    };
  }

  // ── HALFTONE (animated comic dot pattern) ──
  function makeHalftone(ctx, color, getW, getH) {
    var t = 0;
    return {
      tick: function() {
        t += 0.01;
        var W = getW(), H = getH();
        var spacing = 24;
        for (var y = 0; y < H + spacing; y += spacing) {
          for (var x = 0; x < W + spacing; x += spacing) {
            var wave = Math.sin((x + y) * 0.02 + t) * 0.5 + 0.5;
            var r = wave * 4 + 1;
            ctx.beginPath();
            ctx.arc(x + Math.sin(t + y * 0.05) * 4, y + Math.cos(t + x * 0.05) * 4, r, 0, Math.PI * 2);
            ctx.fillStyle = color;
            ctx.globalAlpha = wave * 0.4;
            ctx.fill();
          }
        }
        ctx.globalAlpha = 1;
      }
    };
  }


  // ── WEB SLINGING (Spider-Man) — diagonal web strands ──
  function makeWebs(ctx, color, getW, getH) {
    var webs = [];
    var nextWeb = 20;
    function spawn() {
      var W = getW(), H = getH();
      // Pick a random edge corner-ish anchor point
      var fromX, fromY, toX, toY;
      var corner = Math.floor(Math.random() * 4);
      if (corner === 0)      { fromX = 0;     fromY = Math.random() * H * 0.5; }
      else if (corner === 1) { fromX = W;     fromY = Math.random() * H * 0.5; }
      else if (corner === 2) { fromX = 0;     fromY = H; }
      else                   { fromX = W;     fromY = H; }
      toX = W * 0.3 + Math.random() * W * 0.4;
      toY = H * 0.3 + Math.random() * H * 0.4;
      webs.push({
        fx: fromX, fy: fromY, tx: toX, ty: toY,
        progress: 0, life: 1.0,
        strands: 1 + Math.floor(Math.random() * 3)
      });
    }
    return {
      tick: function() {
        nextWeb--;
        if (nextWeb <= 0) {
          spawn();
          nextWeb = Math.floor(Math.random() * 60 + 30);
        }
        for (var i = webs.length - 1; i >= 0; i--) {
          var w = webs[i];
          if (w.progress < 1) w.progress = Math.min(1, w.progress + 0.05);
          else w.life -= 0.008;
          if (w.life <= 0) { webs.splice(i, 1); continue; }
          // Main strand
          var endX = w.fx + (w.tx - w.fx) * w.progress;
          var endY = w.fy + (w.ty - w.fy) * w.progress;
          ctx.strokeStyle = color;
          ctx.globalAlpha = w.life * 0.9;
          ctx.lineWidth = 1.4;
          ctx.shadowColor = color;
          ctx.shadowBlur = 6;
          ctx.beginPath();
          ctx.moveTo(w.fx, w.fy);
          ctx.lineTo(endX, endY);
          ctx.stroke();
          // Cross-strands at the anchor
          if (w.progress >= 1) {
            for (var s = 0; s < w.strands; s++) {
              var ang = (Math.PI * 2 * s) / w.strands + 0.4;
              var len = 22 + s * 8;
              ctx.globalAlpha = w.life * 0.6;
              ctx.lineWidth = 0.8;
              ctx.beginPath();
              ctx.moveTo(w.tx, w.ty);
              ctx.lineTo(w.tx + Math.cos(ang) * len, w.ty + Math.sin(ang) * len);
              ctx.stroke();
            }
          }
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── HEAT VISION (Superman) — twin red beams sweeping ──
  function makeHeatVision(ctx, color, getW, getH) {
    var t = 0;
    var beams = [];
    var nextBeam = 0;
    function spawn() {
      var H = getH();
      var eyeY = H * 0.35;
      var eyeGap = 80;
      beams.push({
        eyeY: eyeY,
        sweepStart: -Math.PI * 0.15,
        sweepProgress: 0,
        life: 1.0
      });
    }
    return {
      tick: function() {
        t += 0.02;
        nextBeam--;
        if (nextBeam <= 0) {
          spawn();
          nextBeam = 180;
        }
        var W = getW(), H = getH();
        for (var i = beams.length - 1; i >= 0; i--) {
          var b = beams[i];
          b.sweepProgress = Math.min(1, b.sweepProgress + 0.018);
          if (b.sweepProgress >= 1) b.life -= 0.025;
          if (b.life <= 0) { beams.splice(i, 1); continue; }
          var sweepAngle = b.sweepStart + b.sweepProgress * 0.3;
          var leftX = W * 0.42, rightX = W * 0.58;
          for (var eyeIdx = 0; eyeIdx < 2; eyeIdx++) {
            var ex = eyeIdx === 0 ? leftX : rightX;
            var ey = b.eyeY;
            var endX = ex + Math.cos(sweepAngle) * W * 1.2;
            var endY = ey + Math.sin(sweepAngle) * W * 1.2;
            // Outer glow
            var grad = ctx.createLinearGradient(ex, ey, endX, endY);
            grad.addColorStop(0, color);
            grad.addColorStop(0.3, color);
            grad.addColorStop(1, 'rgba(255,80,80,0)');
            ctx.strokeStyle = grad;
            ctx.lineWidth = 22;
            ctx.globalAlpha = b.life * 0.18;
            ctx.shadowColor = color;
            ctx.shadowBlur = 30;
            ctx.beginPath();
            ctx.moveTo(ex, ey);
            ctx.lineTo(endX, endY);
            ctx.stroke();
            // Inner core
            ctx.lineWidth = 4;
            ctx.globalAlpha = b.life * 0.85;
            ctx.strokeStyle = '#fff';
            ctx.beginPath();
            ctx.moveTo(ex, ey);
            ctx.lineTo(endX, endY);
            ctx.stroke();
          }
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── MAGIC RUNES (Doctor Strange) — rotating mystic circles ──
  function makeMagicRunes(ctx, color, getW, getH) {
    var runes = [];
    var nextRune = 0;
    function spawn() {
      var W = getW(), H = getH();
      runes.push({
        x: Math.random() * W,
        y: Math.random() * H,
        size: Math.random() * 60 + 50,
        rot: 0,
        rotSpeed: (Math.random() < 0.5 ? -1 : 1) * (Math.random() * 0.015 + 0.005),
        life: 1.0,
        fadeIn: 0,
        rings: 2 + Math.floor(Math.random() * 2)
      });
    }
    return {
      tick: function() {
        nextRune--;
        if (nextRune <= 0 && runes.length < 5) {
          spawn();
          nextRune = Math.floor(Math.random() * 100 + 60);
        }
        for (var i = runes.length - 1; i >= 0; i--) {
          var r = runes[i];
          r.rot += r.rotSpeed;
          r.fadeIn = Math.min(1, r.fadeIn + 0.03);
          r.life -= 0.005;
          if (r.life <= 0) { runes.splice(i, 1); continue; }
          var alpha = Math.min(r.fadeIn, r.life);
          ctx.save();
          ctx.translate(r.x, r.y);
          ctx.rotate(r.rot);
          ctx.strokeStyle = color;
          ctx.shadowColor = color;
          ctx.shadowBlur = 14;
          // Outer ring
          ctx.globalAlpha = alpha * 0.8;
          ctx.lineWidth = 1.5;
          ctx.beginPath();
          ctx.arc(0, 0, r.size, 0, Math.PI * 2);
          ctx.stroke();
          // Inner ring
          ctx.lineWidth = 0.8;
          ctx.beginPath();
          ctx.arc(0, 0, r.size * 0.7, 0, Math.PI * 2);
          ctx.stroke();
          // Spokes (rune-like)
          var spokes = 8;
          for (var s = 0; s < spokes; s++) {
            var ang = (Math.PI * 2 * s) / spokes;
            var x1 = Math.cos(ang) * r.size * 0.7;
            var y1 = Math.sin(ang) * r.size * 0.7;
            var x2 = Math.cos(ang) * r.size;
            var y2 = Math.sin(ang) * r.size;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
          }
          // Inner pentagram
          ctx.lineWidth = 0.6;
          ctx.globalAlpha = alpha * 0.5;
          ctx.beginPath();
          for (var p = 0; p < 5; p++) {
            var a1 = (Math.PI * 2 * p) / 5 - Math.PI / 2;
            var a2 = (Math.PI * 2 * ((p + 2) % 5)) / 5 - Math.PI / 2;
            ctx.moveTo(Math.cos(a1) * r.size * 0.45, Math.sin(a1) * r.size * 0.45);
            ctx.lineTo(Math.cos(a2) * r.size * 0.45, Math.sin(a2) * r.size * 0.45);
          }
          ctx.stroke();
          ctx.restore();
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── COSMIC (Captain Marvel / Silver Surfer) — shooting stars/comets ──
  function makeCosmic(ctx, color, getW, getH) {
    var comets = [];
    var nextComet = 0;
    function spawn() {
      var W = getW(), H = getH();
      var fromTop = Math.random() < 0.5;
      var fx = fromTop ? Math.random() * W : -50;
      var fy = fromTop ? -50 : Math.random() * H * 0.5;
      var ang = Math.random() * 0.4 + 0.6; // diagonal-ish
      var sp = Math.random() * 6 + 8;
      comets.push({
        x: fx, y: fy,
        vx: Math.cos(ang) * sp,
        vy: Math.sin(ang) * sp,
        trail: [],
        life: 1.0,
        radius: Math.random() * 2 + 2
      });
    }
    return {
      tick: function() {
        nextComet--;
        if (nextComet <= 0) {
          spawn();
          nextComet = Math.floor(Math.random() * 50 + 20);
        }
        var W = getW(), H = getH();
        for (var i = comets.length - 1; i >= 0; i--) {
          var c = comets[i];
          c.trail.push({ x: c.x, y: c.y });
          if (c.trail.length > 18) c.trail.shift();
          c.x += c.vx;
          c.y += c.vy;
          if (c.x > W + 60 || c.y > H + 60) c.life -= 0.1;
          if (c.life <= 0) { comets.splice(i, 1); continue; }
          // Trail
          for (var t = 0; t < c.trail.length; t++) {
            var pt = c.trail[t];
            var alpha = (t / c.trail.length) * c.life * 0.9;
            ctx.beginPath();
            ctx.arc(pt.x, pt.y, c.radius * (t / c.trail.length), 0, Math.PI * 2);
            ctx.fillStyle = t > c.trail.length - 4 ? '#fff' : color;
            ctx.globalAlpha = alpha;
            ctx.shadowColor = color;
            ctx.shadowBlur = 12;
            ctx.fill();
          }
          // Head
          ctx.beginPath();
          ctx.arc(c.x, c.y, c.radius + 1, 0, Math.PI * 2);
          ctx.fillStyle = '#fff';
          ctx.globalAlpha = c.life;
          ctx.shadowBlur = 18;
          ctx.fill();
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── FROST (Iceman / Frozone) — crystals growing and dispersing ──
  function makeFrost(ctx, color, getW, getH) {
    var crystals = [];
    var nextCrystal = 0;
    function spawn() {
      var W = getW(), H = getH();
      crystals.push({
        x: Math.random() * W,
        y: Math.random() * H,
        size: 0,
        maxSize: Math.random() * 25 + 15,
        rot: Math.random() * Math.PI,
        life: 1.0,
        fading: false
      });
    }
    return {
      tick: function() {
        nextCrystal--;
        if (nextCrystal <= 0 && crystals.length < 30) {
          spawn();
          nextCrystal = Math.floor(Math.random() * 18 + 6);
        }
        for (var i = crystals.length - 1; i >= 0; i--) {
          var c = crystals[i];
          if (c.size < c.maxSize) c.size += 0.6;
          else { c.fading = true; c.life -= 0.015; }
          if (c.life <= 0) { crystals.splice(i, 1); continue; }
          ctx.save();
          ctx.translate(c.x, c.y);
          ctx.rotate(c.rot);
          ctx.strokeStyle = color;
          ctx.shadowColor = color;
          ctx.shadowBlur = 10;
          ctx.globalAlpha = c.life * 0.85;
          ctx.lineWidth = 1;
          // Snowflake — 6 arms with branches
          for (var arm = 0; arm < 6; arm++) {
            var a = (Math.PI * 2 * arm) / 6;
            var ex = Math.cos(a) * c.size;
            var ey = Math.sin(a) * c.size;
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(ex, ey);
            ctx.stroke();
            // Branches at midpoint and 2/3 point
            for (var br = 0; br < 2; br++) {
              var f = 0.45 + br * 0.25;
              var mx = Math.cos(a) * c.size * f;
              var my = Math.sin(a) * c.size * f;
              var bl = c.size * 0.22;
              ctx.beginPath();
              ctx.moveTo(mx, my);
              ctx.lineTo(mx + Math.cos(a + 0.6) * bl, my + Math.sin(a + 0.6) * bl);
              ctx.moveTo(mx, my);
              ctx.lineTo(mx + Math.cos(a - 0.6) * bl, my + Math.sin(a - 0.6) * bl);
              ctx.stroke();
            }
          }
          ctx.restore();
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── BATS (Batman) — silhouettes flying across ──
  function makeBats(ctx, color, getW, getH) {
    var bats = [];
    var nextBat = 0;
    function spawn() {
      var W = getW(), H = getH();
      var fromLeft = Math.random() < 0.5;
      bats.push({
        x: fromLeft ? -40 : W + 40,
        y: Math.random() * H * 0.7 + H * 0.1,
        vx: (fromLeft ? 1 : -1) * (Math.random() * 1.4 + 1.2),
        vy: (Math.random() - 0.5) * 0.6,
        size: Math.random() * 14 + 16,
        wingPhase: Math.random() * Math.PI,
        baseY: 0
      });
    }
    return {
      tick: function() {
        nextBat--;
        if (nextBat <= 0) {
          spawn();
          nextBat = Math.floor(Math.random() * 60 + 20);
        }
        var W = getW(), H = getH();
        for (var i = bats.length - 1; i >= 0; i--) {
          var b = bats[i];
          b.x += b.vx;
          b.y += b.vy + Math.sin(b.wingPhase * 0.5) * 0.5;
          b.wingPhase += 0.35;
          if (b.x < -60 || b.x > W + 60) { bats.splice(i, 1); continue; }
          var wing = Math.sin(b.wingPhase) * 0.5 + 0.5;
          ctx.save();
          ctx.translate(b.x, b.y);
          if (b.vx < 0) ctx.scale(-1, 1);
          ctx.fillStyle = color;
          ctx.globalAlpha = 0.85;
          ctx.shadowColor = color;
          ctx.shadowBlur = 10;
          // Bat silhouette using path
          var s = b.size;
          var w = s * (0.6 + wing * 0.6); // wing extension
          ctx.beginPath();
          ctx.moveTo(0, 0);
          // Right wing
          ctx.bezierCurveTo(s * 0.3, -s * 0.3 - wing * s * 0.15, s * 0.7, -s * 0.2, w, -wing * s * 0.4);
          ctx.bezierCurveTo(w * 0.85, -wing * s * 0.05, s * 0.85, s * 0.05, s * 0.6, s * 0.1);
          ctx.bezierCurveTo(s * 0.4, s * 0.05, s * 0.2, s * 0.15, 0, s * 0.05);
          // Left wing (mirror)
          ctx.bezierCurveTo(-s * 0.2, s * 0.15, -s * 0.4, s * 0.05, -s * 0.6, s * 0.1);
          ctx.bezierCurveTo(-s * 0.85, s * 0.05, -w * 0.85, -wing * s * 0.05, -w, -wing * s * 0.4);
          ctx.bezierCurveTo(-s * 0.7, -s * 0.2, -s * 0.3, -s * 0.3 - wing * s * 0.15, 0, 0);
          ctx.fill();
          ctx.restore();
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── SYMBIOTE (Venom) — black tendrils oozing from edges ──
  function makeSymbiote(ctx, color, getW, getH) {
    var tendrils = [];
    var nextTendril = 0;
    function spawn() {
      var W = getW(), H = getH();
      var edge = Math.floor(Math.random() * 4);
      var sx, sy, dirAngle;
      if (edge === 0)      { sx = Math.random() * W; sy = 0;  dirAngle = Math.PI * 0.5 + (Math.random() - 0.5) * 0.6; }
      else if (edge === 1) { sx = W; sy = Math.random() * H;  dirAngle = Math.PI + (Math.random() - 0.5) * 0.6; }
      else if (edge === 2) { sx = Math.random() * W; sy = H;  dirAngle = -Math.PI * 0.5 + (Math.random() - 0.5) * 0.6; }
      else                 { sx = 0; sy = Math.random() * H;  dirAngle = (Math.random() - 0.5) * 0.6; }
      tendrils.push({
        sx: sx, sy: sy, dir: dirAngle,
        length: 0,
        maxLength: Math.random() * 200 + 150,
        thickness: Math.random() * 4 + 4,
        wiggle: Math.random() * 4 + 2,
        wigglePhase: 0,
        life: 1.0
      });
    }
    return {
      tick: function() {
        nextTendril--;
        if (nextTendril <= 0 && tendrils.length < 8) {
          spawn();
          nextTendril = Math.floor(Math.random() * 50 + 25);
        }
        for (var i = tendrils.length - 1; i >= 0; i--) {
          var t = tendrils[i];
          if (t.length < t.maxLength) t.length += 3;
          else t.life -= 0.012;
          t.wigglePhase += 0.05;
          if (t.life <= 0) { tendrils.splice(i, 1); continue; }
          // Draw tendril as a wiggly thick line with white edge highlight
          var segs = 24;
          ctx.shadowColor = color;
          ctx.shadowBlur = 8;
          ctx.lineCap = 'round';
          // Outer dark
          ctx.strokeStyle = '#0a0a18';
          ctx.lineWidth = t.thickness + 2;
          ctx.globalAlpha = t.life;
          ctx.beginPath();
          for (var s = 0; s <= segs; s++) {
            var f = s / segs;
            var dist = t.length * f;
            var nx = t.sx + Math.cos(t.dir) * dist + Math.sin(t.wigglePhase + f * 4) * t.wiggle * f;
            var ny = t.sy + Math.sin(t.dir) * dist + Math.cos(t.wigglePhase + f * 4) * t.wiggle * f;
            if (s === 0) ctx.moveTo(nx, ny);
            else ctx.lineTo(nx, ny);
          }
          ctx.stroke();
          // Inner highlight
          ctx.strokeStyle = color;
          ctx.lineWidth = 1.2;
          ctx.globalAlpha = t.life * 0.5;
          ctx.beginPath();
          for (var s2 = 0; s2 <= segs; s2++) {
            var f2 = s2 / segs;
            var dist2 = t.length * f2;
            var nx2 = t.sx + Math.cos(t.dir) * dist2 + Math.sin(t.wigglePhase + f2 * 4) * t.wiggle * f2;
            var ny2 = t.sy + Math.sin(t.dir) * dist2 + Math.cos(t.wigglePhase + f2 * 4) * t.wiggle * f2;
            if (s2 === 0) ctx.moveTo(nx2, ny2);
            else ctx.lineTo(nx2, ny2);
          }
          ctx.stroke();
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0; ctx.lineCap = 'butt';
      }
    };
  }

  // ── SHOCKWAVE (Sonic / Black Bolt) — concentric expanding rings ──
  function makeShockwave(ctx, color, getW, getH) {
    var waves = [];
    var nextWave = 0;
    function spawn() {
      var W = getW(), H = getH();
      waves.push({
        x: Math.random() * W,
        y: Math.random() * H * 0.7 + H * 0.1,
        radius: 0,
        maxRadius: Math.random() * 200 + 200,
        speed: Math.random() * 2 + 2.5,
        life: 1.0,
        rings: 3
      });
    }
    return {
      tick: function() {
        nextWave--;
        if (nextWave <= 0) {
          spawn();
          nextWave = Math.floor(Math.random() * 80 + 40);
        }
        for (var i = waves.length - 1; i >= 0; i--) {
          var w = waves[i];
          w.radius += w.speed;
          if (w.radius > w.maxRadius) w.life -= 0.025;
          if (w.life <= 0) { waves.splice(i, 1); continue; }
          ctx.shadowColor = color;
          ctx.shadowBlur = 14;
          for (var ring = 0; ring < w.rings; ring++) {
            var r = w.radius - ring * 18;
            if (r <= 0) continue;
            var ringAlpha = w.life * (1 - ring / w.rings) * 0.7;
            ctx.strokeStyle = color;
            ctx.globalAlpha = ringAlpha;
            ctx.lineWidth = 2 - ring * 0.4;
            ctx.beginPath();
            ctx.arc(w.x, w.y, r, 0, Math.PI * 2);
            ctx.stroke();
          }
          // Bright center pulse on first frame
          if (w.radius < 30) {
            ctx.beginPath();
            ctx.arc(w.x, w.y, 30 - w.radius, 0, Math.PI * 2);
            ctx.fillStyle = '#fff';
            ctx.globalAlpha = w.life * (1 - w.radius / 30);
            ctx.fill();
          }
        }
        ctx.globalAlpha = 1; ctx.shadowBlur = 0;
      }
    };
  }

  // ── PRODUCT SPOTLIGHT auto-rotator ──
  function initSpotlights() {
    var spots = document.querySelectorAll('[data-spotlight]');
    for (var i = 0; i < spots.length; i++) {
      bindSpotlight(spots[i]);
    }
  }
  function bindSpotlight(root) {
    var slides = root.querySelectorAll('[data-spotlight-slide]');
    var dots   = root.querySelectorAll('[data-spotlight-go]');
    var prev   = root.querySelector('[data-spotlight-prev]');
    var next   = root.querySelector('[data-spotlight-next]');
    if (slides.length < 2) return;
    var rotateMs = parseInt(root.dataset.rotateMs, 10) || 5000;
    var current = 0;
    var auto = null;

    function show(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === idx);
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === idx);
      }
      current = idx;
    }
    function startAuto() {
      stopAuto();
      auto = setInterval(function() { show(current + 1); }, rotateMs);
    }
    function stopAuto() {
      if (auto) clearInterval(auto);
      auto = null;
    }
    function bump(dir) { stopAuto(); show(current + dir); startAuto(); }

    if (prev) prev.addEventListener('click', function() { bump(-1); });
    if (next) next.addEventListener('click', function() { bump(1); });
    for (var d = 0; d < dots.length; d++) {
      (function(d){
        dots[d].addEventListener('click', function() {
          stopAuto();
          show(d);
          startAuto();
        });
      })(d);
    }
    // Pause on hover
    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    startAuto();
  }


  function initScrollReveal() {
    var inDesignMode = (typeof window.Shopify !== 'undefined' && window.Shopify.designMode === true);
    if (inDesignMode || !('IntersectionObserver' in window)) {
      var els = document.querySelectorAll('.reveal');
      for (var i = 0; i < els.length; i++) els[i].classList.add('in');
      return;
    }
    // Activate the hide-then-fade animation only when we know the observer
    // is supported. Otherwise the base .reveal stays at opacity:1 (visible).
    document.documentElement.classList.add('symh-reveal-on');
    var obs = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) entries[i].target.classList.add('in');
      }
    }, { threshold: 0.07 });
    var el2 = document.querySelectorAll('.reveal');
    for (var j = 0; j < el2.length; j++) obs.observe(el2[j]);
  }

  // Mega menu: each .nav-dropdown--mega has its own .mega-panel sibling.
  // CSS-only :hover is unreliable when multiple panels stack at the same
  // absolute position — the cursor can leave the trigger and land on a
  // different (invisible) panel that doesn't activate. JS manages a single
  // .is-open class with a grace timer so cursor travel doesn't kill it.
  function initMegaMenu() {
    var triggers = document.querySelectorAll('.nav-dropdown--mega');
    if (!triggers.length) return;
    var openItem = null;
    var closeTimer = null;
    var openTimer = null;

    function close(item) {
      if (item) item.classList.remove('is-open');
      if (openItem === item) openItem = null;
    }
    function open(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (openItem && openItem !== item) close(openItem);
      item.classList.add('is-open');
      openItem = item;
    }
    // Hover intent (2026-10-11, Rich: "pops up with mouse moves too easily"): a
    // cursor merely crossing the row no longer opens anything — the pointer has
    // to rest on the item for 140ms (80ms to switch while another panel is
    // already open, so a drag across the row does not flash every panel).
    // Keyboard focus stays instant.
    function openSoon(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openTimer) clearTimeout(openTimer);
      openTimer = setTimeout(function () { openTimer = null; open(item); }, openItem ? 80 : 140);
    }
    function cancelOpen() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    }
    function scheduleClose() {
      // closes whatever is open — the item being left may be one the cursor
      // only brushed while another panel was showing (2026-10-11)
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        close(openItem);
        closeTimer = null;
      }, 300); // 300ms grace — generous for slower cursors
    }

    for (var i = 0; i < triggers.length; i++) {
      (function (trig) {
        var panel = trig.querySelector('.mega-panel');
        if (!panel) return;
        trig.addEventListener('mouseenter', function () { openSoon(trig); });
        trig.addEventListener('mouseleave', function () { cancelOpen(); scheduleClose(trig); });
        // Panel needs its own listeners so hovering it also keeps it open.
        panel.addEventListener('mouseenter', function () { open(trig); });
        panel.addEventListener('mouseleave', function (e) {
          // Back up onto the item's own label is not a leave: the panel is a
          // child of the trigger, so the trigger never re-fires mouseenter and
          // the 300ms close ran while the cursor sat on the label (2026-10-11).
          if (e.relatedTarget && trig.contains(e.relatedTarget)) return;
          scheduleClose(trig);
        });
        // Keyboard accessibility: focus inside trigger or panel keeps it open
        trig.addEventListener('focusin', function () { open(trig); });
        trig.addEventListener('focusout', function (e) {
          // Only close if focus left the entire trigger (including panel)
          if (!trig.contains(e.relatedTarget)) scheduleClose(trig);
        });
      })(triggers[i]);
    }
    // Close all on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) close(openItem);
    });
  }

function initMobileNav() {
    var btn = document.querySelector('.hamburger');
    var nav = document.querySelector('.mobile-nav');
    if (!btn || !nav) return;

    // Build backdrop
    var backdrop = document.querySelector('.mobile-nav-overlay');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'mobile-nav-overlay';
      document.body.appendChild(backdrop);
    }

    function openNav() {
      nav.classList.add('open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeNav() {
      nav.classList.remove('open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', function(){
      if (nav.classList.contains('open')) closeNav(); else openNav();
    });
    backdrop.addEventListener('click', closeNav);

    var closeBtn = nav.querySelector('.mobile-nav__close');
    if (closeBtn) closeBtn.addEventListener('click', closeNav);

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && nav.classList.contains('open')) closeNav();
    });

    // Close when navigating to a link
    var links = nav.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', closeNav);
    }
  }

  function initHeaderScroll() {
    var h = document.querySelector('.symh-header');
    if (!h) return;
    var last = 0;
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      if (y > 100 && y > last) h.style.transform = 'translateY(-100%)';
      else h.style.transform = '';
      if (y > 40) h.classList.add('scrolled');
      else h.classList.remove('scrolled');
      last = y;
    }, { passive: true });
  }

  // ── ROTATOR ──
  // Each .rotator gets cycled. Slides have .rotator-slide. One has .active.
  // Auto-advances every interval (defaults to 5500ms). Pauses on hover.
  function initRotators() {
    var rotators = document.querySelectorAll('[data-rotator]');
    for (var i = 0; i < rotators.length; i++) {
      setupRotator(rotators[i]);
    }
  }

  function setupRotator(root) {
    var slides = root.querySelectorAll('.rotator-slide');
    if (slides.length === 0) return;
    var dotsWrap = root.querySelector('.rotator-dots');
    var prev = root.querySelector('[data-rot-prev]');
    var next = root.querySelector('[data-rot-next]');
    var counterCur = root.querySelector('[data-rot-current]');
    var counterTot = root.querySelector('[data-rot-total]');
    var interval = parseInt(root.dataset.interval || '5500', 10);
    var current = 0;
    var timer = null;
    var paused = false;

    // Build dots
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('button');
        d.className = 'rotator-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Slide ' + (i+1));
        (function(idx){
          d.addEventListener('click', function(){ goTo(idx); restart(); });
        })(i);
        dotsWrap.appendChild(d);
      }
    }
    if (counterTot) counterTot.textContent = String(slides.length).padStart(2,'0');

    // Initial state
    slides[0].classList.add('active');

    function goTo(idx) {
      if (idx === current) return;
      var prev_i = current;
      slides[prev_i].classList.add('exiting');
      slides[prev_i].classList.remove('active');
      setTimeout(function(){ slides[prev_i].classList.remove('exiting'); }, 800);
      slides[idx].classList.add('active');
      current = idx;
      // Update dots
      var dots = root.querySelectorAll('.rotator-dot');
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('active', k === idx);
      if (counterCur) counterCur.textContent = String(idx+1).padStart(2,'0');
    }

    function tick() { goTo((current + 1) % slides.length); }

    function start() {
      if (timer || paused || slides.length < 2) return;
      timer = setInterval(tick, interval);
    }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function(){ goTo((current - 1 + slides.length) % slides.length); restart(); });
    if (next) next.addEventListener('click', function(){ goTo((current + 1) % slides.length); restart(); });

    root.addEventListener('mouseenter', function(){ paused = true; stop(); });
    root.addEventListener('mouseleave', function(){ paused = false; start(); });

    // Pause when not in viewport
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries){
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) start();
          else stop();
        }
      }, { threshold: 0.3 });
      obs.observe(root);
    } else {
      start();
    }
  }

  // ── CART ──
  window.SYMH = window.SYMH || {};

  window.SYMH.openCart = function () {
    var o = document.querySelector('.cart-overlay');
    var d = document.querySelector('.cart-drawer');
    if (o) o.classList.add('open');
    if (d) d.classList.add('open');
    window.SYMH.refreshCart();
  };
  window.SYMH.closeCart = function () {
    var o = document.querySelector('.cart-overlay');
    var d = document.querySelector('.cart-drawer');
    if (o) o.classList.remove('open');
    if (d) d.classList.remove('open');
  };

  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.cart-overlay')) window.SYMH.closeCart();
    if (e.target.closest && e.target.closest('.cart-drawer-close')) window.SYMH.closeCart();
  });

  window.SYMH.addToCart = function (variantId, title, qty) {
    qty = qty || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    }).then(function(res){
      if (!res.ok) throw new Error();
      return res.json();
    }).then(function(item){
      // Notify analytics pixels. Custom AJAX drawers (like ours) can be missed
      // by auto-detection, so we fire explicitly. Wrapped in try/catch so a
      // tracking failure can never block the cart from updating.
      try {
        if (typeof window.TriplePixel === 'function' && item && item.product_id) {
          window.TriplePixel('AddToCart', {
            item: String(item.product_id),
            q: qty,
            v: String(item.variant_id || variantId)
          });
        }
      } catch (e) { /* swallow — tracking must never break checkout flow */ }

      showToast('◆ Added — ' + title);
      updateCartCount();
      window.SYMH.openCart();
    }).catch(function(){
      showToast('Could not add — redirecting...');
      setTimeout(function(){ window.location = '/cart'; }, 1200);
    });
  };

  // 2026-10-13: a reservation added to the cart before the cutoff could still
  // be checked out after it (the advance-order page only hides cards when it
  // draws them). The rule is 21:00 America/New_York on the day before FOC.
  // Late reservations are removed from the cart here and the shopper is told.
  function reservationCutoffPassed(foc) {
    var m = String(foc || '').match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/), d = null, mo = 0, da = 0;
    if (m) { mo = Number(m[1]); da = Number(m[2]); d = new Date(Number(m[3]), mo - 1, da); }
    else { var i = String(foc || '').match(/^(\d{4})-(\d{2})-(\d{2})/); if (i) { mo = Number(i[2]); da = Number(i[3]); d = new Date(Number(i[1]), mo - 1, da); } }
    // an impossible date (13/45/2026) would roll into a real one; refuse it instead
    if (!d || isNaN(d) || d.getMonth() !== mo - 1 || d.getDate() !== da) return false;
    var eve = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
    var cutoffMs = Date.UTC(eve.getFullYear(), eve.getMonth(), eve.getDate(), 21, 0, 0);
    var o = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10); });
    } catch (e) { return false; }
    var nowMs = Date.UTC(o.year, o.month - 1, o.day, o.hour, o.minute, o.second);
    return nowMs >= cutoffMs;
  }
  window.SYMH.pruneLateReservations = function (cart) {
    var late = ((cart && cart.items) || []).filter(function (it) {
      return it.properties && it.properties._advance_order === 'yes' && reservationCutoffPassed(it.properties.FOC);
    });
    if (!late.length) return Promise.resolve(0);
    var updates = {};
    late.forEach(function (it) { updates[it.key] = 0; });
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function (r) {
        // a refused update (4xx/5xx) leaves the line in place: no notice, no
        // reload, or the cart page would reload itself forever (Codex 2026-10-13)
        if (!r.ok) return 0;
        try { sessionStorage.setItem('symhLateRemoved', String(late.length)); } catch (e) {}
        return late.length;
      }).catch(function () { return 0; });
  };
  window.SYMH.lateReservationNotice = function (n) {
    return '<div class="cart-late-note" style="margin:0 0 10px;padding:9px 11px;border:1px solid var(--pink,#ff2cd5);font-size:11px;line-height:1.5;letter-spacing:.04em;">' +
      (n === 1 ? 'One reservation was removed: ' : n + ' reservations were removed: ') +
      'its order window closed at 9 PM Eastern on the Sunday before final order cutoff. Reservations are open until then for every upcoming book.</div>';
  };

  window.SYMH.refreshCart = function () {
    return fetch('/cart.js').then(function(r){return r.json();}).then(function (cart) {
      return window.SYMH.pruneLateReservations(cart).then(function (n) {
        if (!n) return cart;
        return fetch('/cart.js').then(function (r) { return r.json(); });
      });
    }).then(function (cart) {
      renderCartDrawer(cart);
      var removed = 0;
      try { removed = parseInt(sessionStorage.getItem('symhLateRemoved') || '0', 10); sessionStorage.removeItem('symhLateRemoved'); } catch (e) {}
      if (removed) {
        var items = document.querySelector('.cart-drawer-items');
        if (items) items.insertAdjacentHTML('afterbegin', window.SYMH.lateReservationNotice(removed));
      }
      // 2026-10-13: announce the change. The free-shipping bar
      // (snippets/shipping-cap-bar.liquid) listens for cart:updated; its
      // MutationObserver only knows Dawn's <cart-drawer> element, which this
      // theme does not have, so without this the bar in the drawer never
      // re-read after a quantity change.
      try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); } catch (e) {}
    }).catch(function(){});
  };

  window.SYMH.updateItem = function (key, qty) {
    var u = {}; u[key] = qty;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: u })
    }).then(function(){ window.SYMH.refreshCart(); updateCartCount(); });
  };

  function renderCartDrawer(cart) {
    var items = document.querySelector('.cart-drawer-items');
    var sub = document.querySelector('.cart-drawer-subtotal span:last-child');
    if (!items) return;
    if (cart.item_count === 0) {
      items.innerHTML = '<div class="cart-empty-msg">◆ Your cart is empty ◆<br><br><a href="/collections/all" style="color:var(--cyan);font-weight:700;letter-spacing:.1em;text-transform:uppercase;font-size:11px;">Shop New Releases →</a></div>';
    } else {
      var html = '';
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        html += '<div class="cart-drawer-item">';
        if (item.image) {
          html += '<img src="' + cdnSize(item.image, 120) + '" alt="' + esc(item.product_title) + '" loading="lazy">';
        } else if (item.properties && item.properties._cover) {
          // Fallback: PLR/deposit lines carry the book's cover URL as
          // the _cover property (attached at reserve/deposit add time).
          html += '<img src="' + esc(item.properties._cover) + '" alt="' + esc(item.product_title) + '" loading="lazy">';
        } else {
          html += '<div></div>';
        }
        html += '<div>';
        html += '<div class="cdi-title">' + esc(item.product_title) + '</div>';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          html += '<div class="cdi-variant">' + esc(item.variant_title) + '</div>';
        }
        // Line properties (PLR reservations carry Title/Code/Cover Price/
        // FOC/Arrives; deposit lines carry "For: <item title>"). Skip
        // any key starting with '_' (Shopify hidden convention).
        if (item.properties) {
          var propsHtml = '';
          for (var pk in item.properties) {
            if (!Object.prototype.hasOwnProperty.call(item.properties, pk)) continue;
            if (pk.charAt(0) === '_') continue;
            var pv = item.properties[pk];
            if (pv == null || pv === '') continue;
            var cls = 'cdi-prop' + (pk === 'Cover Price' ? ' cdi-prop--price' : '');
            propsHtml += '<div class="' + cls + '"><span class="cdi-prop-k">' +
                          esc(pk) + ':</span> <span class="cdi-prop-v">' +
                          esc(String(pv)) + '</span></div>';
          }
          if (propsHtml) {
            html += '<div class="cdi-props">' + propsHtml + '</div>';
          }
        }
        html += '<div class="cdi-price">' + money(item.line_price) + '</div>';
        html += '</div>';
        html += '<div><div class="cdi-qty">';
        html += '<button onclick="SYMH.updateItem(\'' + item.key + '\',' + (item.quantity-1) + ')">−</button>';
        html += '<span>' + item.quantity + '</span>';
        html += '<button onclick="SYMH.updateItem(\'' + item.key + '\',' + (item.quantity+1) + ')">+</button>';
        html += '</div></div></div>';
      }
      items.innerHTML = html;
    }
    if (sub) sub.textContent = money(cart.total_price);
  }

  function updateCartCount() {
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(data){
      var els = document.querySelectorAll('.cart-count');
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = data.item_count;
        els[i].style.display = data.item_count > 0 ? 'flex' : 'none';
      }
    }).catch(function(){});
  }

  function showToast(msg) {
    var t = document.getElementById('symh-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'symh-toast';
      t.className = 'cart-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function(){ t.classList.remove('show'); }, 2800);
  }

  function money(c) { return '$' + (c / 100).toFixed(2).replace('.00', ''); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }
  // Resize a Shopify CDN image URL by appending the proper size to the filename,
  // preserving any extension (jpg/jpeg/png/gif/webp) and query string.
  function cdnSize(url, w) {
    if (!url) return url;
    return String(url).replace(/(\.(jpe?g|png|gif|webp))(\?.*)?$/i, '_' + w + 'x$1$3');
  }

  window.SYMH.initVariants = function () {
    var btns = document.querySelectorAll('.variant-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var grp = this.closest('.variant-btns');
        var siblings = grp.querySelectorAll('.variant-btn');
        for (var j = 0; j < siblings.length; j++) siblings[j].classList.remove('selected');
        this.classList.add('selected');
        var selected = [];
        var groups = document.querySelectorAll('.variant-btns');
        for (var k = 0; k < groups.length; k++) {
          var sel = groups[k].querySelector('.selected');
          if (sel) selected.push(sel.getAttribute('data-value'));
        }
        var variants = window.__SYMH_VARIANTS || [];
        for (var v = 0; v < variants.length; v++) {
          var match = true;
          for (var p = 0; p < variants[v].options.length; p++) {
            if (selected[p] && variants[v].options[p] !== selected[p]) { match = false; break; }
          }
          if (match) {
            var atc = document.querySelector('.atc-btn');
            if (atc) {
              atc.dataset.variantId = variants[v].id;
              atc.disabled = !variants[v].available;
              atc.textContent = variants[v].available ? 'Add to Cart' : 'Sold Out';
            }
            var pe = document.querySelector('.product-price');
            if (pe) pe.textContent = money(variants[v].price);
            break;
          }
        }
      });
    }
    var atc = document.querySelector('.atc-btn');
    if (atc) {
      atc.addEventListener('click', function () {
        var vid = this.dataset.variantId;
        var t = (document.querySelector('.product-title') || {}).textContent || '';
        if (vid) window.SYMH.addToCart(parseInt(vid, 10), t);
      });
    }
  };


  // Fade Wall — random product cycling per tile
  function initFadeWalls() {
    var walls = document.querySelectorAll('[data-fadewall]');
    for (var i = 0; i < walls.length; i++) setupFadeWall(walls[i]);
  }
  function setupFadeWall(root) {
    if (!root) return;
    var cycle = (parseInt(root.dataset.cycle, 10) || 7) * 1000;
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.fade-tile'));
    if (tiles.length < 4) return;

    // Build the pool from existing tiles' images and meta
    var pool = tiles.map(function(t){
      var img = t.querySelector('img');
      var titleEl = t.querySelector('.fade-tile__title');
      var priceEl = t.querySelector('.fade-tile__price');
      return {
        i: img ? img.src : '',
        u: t.getAttribute('href'),
        t: titleEl ? titleEl.textContent : '',
        p: priceEl ? priceEl.textContent : ''
      };
    });

    for (var i = 0; i < tiles.length; i++) {
      cycleTile(tiles[i], pool, cycle, i);
    }
  }
  function cycleTile(tile, products, baseCycle, idx) {
    var img = tile.querySelector('img');
    if (!img) return;
    // Stagger: each tile cycles at slightly different intervals
    var jitter = (Math.random() - 0.5) * baseCycle * 0.3;
    var interval = baseCycle + jitter;
    var startDelay = (idx * 200) + (Math.random() * baseCycle * 0.5);
    setTimeout(function tick() {
      img.style.transition = 'opacity 0.6s ease';
      img.style.opacity = '0';
      setTimeout(function() {
        var next = products[Math.floor(Math.random() * products.length)];
        if (next) {
          img.src = next.i;
          img.alt = next.t;
          var link = tile;
          if (link && next.u) link.href = next.u;
          var titleEl = tile.querySelector('.fade-tile__title');
          var priceEl = tile.querySelector('.fade-tile__price');
          if (titleEl) titleEl.textContent = next.t.length > 30 ? next.t.slice(0, 30) + '…' : next.t;
          if (priceEl) priceEl.textContent = next.p;
        }
        img.style.opacity = '1';
        setTimeout(tick, interval);
      }, 600);
    }, startDelay);
  }


  // ── PREDICTIVE SEARCH ──
  var searchDebounce = null;
  window.SYMH.openSearch = function() {
    var ov = document.getElementById('search-overlay');
    var dr = document.getElementById('search-drawer');
    if (ov) ov.classList.add('open');
    if (dr) dr.classList.add('open');
    setTimeout(function(){
      var i = document.getElementById('search-input');
      if (i) i.focus();
    }, 100);
    renderRecentSearches();
  };
  window.SYMH.closeSearch = function() {
    var ov = document.getElementById('search-overlay');
    var dr = document.getElementById('search-drawer');
    if (ov) ov.classList.remove('open');
    if (dr) dr.classList.remove('open');
  };
  function initSearch() {
    var input = document.getElementById('search-input');
    if (!input) return;
    input.addEventListener('input', function() {
      var q = this.value.trim();
      clearTimeout(searchDebounce);
      if (q.length < 2) {
        showSearchEmpty();
        return;
      }
      searchDebounce = setTimeout(function(){ doSearch(q); }, 200);
    });
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        var q = this.value.trim();
        if (q) {
          saveRecentSearch(q);
          window.location = '/search?q=' + encodeURIComponent(q);
        }
      }
      if (e.key === 'Escape') window.SYMH.closeSearch();
    });
    var viewAll = document.getElementById('search-view-all');
    if (viewAll) {
      viewAll.addEventListener('click', function(e) {
        var q = input.value.trim();
        if (q) {
          e.preventDefault();
          saveRecentSearch(q);
          window.location = '/search?q=' + encodeURIComponent(q);
        }
      });
    }
  }
  function showSearchEmpty() {
    var em = document.getElementById('search-empty');
    var rs = document.getElementById('search-results');
    if (em) em.style.display = 'block';
    if (rs) rs.innerHTML = '';
  }
  function doSearch(q) {
    var em = document.getElementById('search-empty');
    var rs = document.getElementById('search-results');
    if (em) em.style.display = 'none';
    if (rs) rs.innerHTML = '<p style="text-align:center;color:var(--text-dim);padding:30px;font-size:11px;letter-spacing:.2em;">SEARCHING…</p>';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=10' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][prefix]=last' +
      '&resources[options][fields]=title,product_type,vendor,tag,variants.sku,variants.barcode';
    fetch(url).then(function(r){return r.json();}).then(function(data){
      renderSearchResults(q, data.resources && data.resources.results || {});
    }).catch(function(){
      if (rs) rs.innerHTML = '<p style="color:var(--pink);padding:20px;">Search failed. Try the Enter key.</p>';
    });
  }
  function renderSearchResults(q, r) {
    var rs = document.getElementById('search-results');
    if (!rs) return;
    var html = '';
    if (r.products && r.products.length) {
      // Defense-in-depth: skip internal:-tagged products even if
      // /search/suggest.json returns them. UNLISTED status is the primary
      // suppressor; this catches any regression.
      r.products = r.products.filter(function(p){
        return !(p.tags && p.tags.some(function(t){ return t.indexOf('internal:') !== -1; }));
      });
    }
    if (r.products && r.products.length) {
      html += '<div class="search-section"><h4>Products</h4><div class="search-product-grid">';
      r.products.forEach(function(p){
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        html += '<a href="' + escapeHTML(p.url || '#') + '" class="search-product">';
        html += '<div class="search-product-img">' + (img ? '<img src="' + escapeHTML(img) + '" alt="" loading="lazy">' : '') + '</div>';
        html += '<div class="search-product-info">';
        html += '<div class="search-product-vendor">' + escapeHTML(p.vendor || '') + '</div>';
        html += '<div class="search-product-title">' + escapeHTML(p.title || '') + '</div>';
        html += '<div class="search-product-price">' + escapeHTML(p.price || '') + '</div>';
        html += '</div></a>';
      });
      html += '</div></div>';
    }
    if (r.collections && r.collections.length) {
      html += '<div class="search-section"><h4>Collections</h4><div class="search-list">';
      r.collections.forEach(function(c){
        html += '<a href="' + escapeHTML(c.url || '#') + '" class="search-list-item">→ ' + escapeHTML(c.title || '') + '</a>';
      });
      html += '</div></div>';
    }
    if (r.pages && r.pages.length) {
      html += '<div class="search-section"><h4>Pages</h4><div class="search-list">';
      r.pages.forEach(function(p){
        html += '<a href="' + escapeHTML(p.url || '#') + '" class="search-list-item">→ ' + escapeHTML(p.title || '') + '</a>';
      });
      html += '</div></div>';
    }
    if (!html) {
      html = '<p style="text-align:center;color:var(--text-dim);padding:30px;">No matches for "' + escapeHTML(q) + '"</p>';
    }
    rs.innerHTML = html;
  }
  function escapeHTML(s) {
    return String(s).replace(/[&<>"\']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }
  function saveRecentSearch(q) {
    try {
      var arr = JSON.parse(localStorage.getItem('symh_recent_search') || '[]');
      arr = arr.filter(function(x){ return x !== q; });
      arr.unshift(q);
      arr = arr.slice(0, 6);
      localStorage.setItem('symh_recent_search', JSON.stringify(arr));
    } catch(e){}
  }
  function renderRecentSearches() {
    var el = document.getElementById('search-recent');
    if (!el) return;
    var arr = [];
    try { arr = JSON.parse(localStorage.getItem('symh_recent_search') || '[]'); } catch(e){}
    if (arr.length === 0) {
      el.parentElement.style.display = 'none';
      return;
    }
    el.parentElement.style.display = 'block';
    el.innerHTML = arr.map(function(q){
      return '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-recent-item">' + escapeHTML(q) + '</a>';
    }).join('');
  }

  // ── WISHLIST (localStorage) ──
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('symh_wishlist') || '[]'); }
    catch(e){ return []; }
  }
  // 2026-09-27: this write had no try/catch while getWishlist() did. A browser
  // that refuses localStorage writes — Safari private mode, iOS with site data
  // blocked, or a full quota — threw QuotaExceededError/SecurityError out of
  // here, up through toggleWishlist and into the inline onclick. The toast had
  // already fired on the line above, so the customer saw "Saved to wishlist",
  // nothing persisted, and refreshWishlistUI() never ran. That is the reported
  // "wishlist does not work": it looks like it worked until you reload.
  // Returns success so the caller can tell the truth instead of guessing.
  function setWishlist(arr) {
    try {
      localStorage.setItem('symh_wishlist', JSON.stringify(arr));
    } catch (e) {
      try { console.warn('[SYMH wishlist] storage unavailable', e); } catch(_) {}
      return false;
    }
    updateWishCount();
    // Same-tab listeners (header tiles, drawer tiles) hear every change here;
    // the `storage` event only fires in OTHER tabs. 2026-10-11.
    try { window.dispatchEvent(new CustomEvent('symh:wishlist', { detail: { handles: arr } })); } catch (e) {}
    return true;
  }
  window.SYMH.toggleWishlist = function(handle, btn) {
    var w = getWishlist();
    var idx = w.indexOf(handle);
    var removing = idx >= 0;
    if (removing) w.splice(idx, 1); else w.unshift(handle);
    // Persist FIRST, then reflect the real outcome. The old order toasted
    // success before writing, so a blocked write still said "Saved".
    if (!setWishlist(w)) {
      showToast('◆ Can\u2019t save your wishlist \u2014 enable site data for this site');
      return;
    }
    if (btn) btn.classList.toggle('is-saved', !removing);
    showToast(removing ? '◆ Removed from wishlist' : '◆ Saved to wishlist');
    refreshWishlistUI();
    wlPush(w, 'replace');
  };
  // Explicit remove for Mission Control's wishlist rail, whose cards come
  // from the account copy: a toggle on a handle this browser never saved
  // would ADD it.
  window.SYMH.removeFromWishlist = function(handle) {
    var w = getWishlist().filter(function(h){ return h !== handle; });
    if (!setWishlist(w)) return false;
    refreshWishlistUI();
    wlPush(w, 'replace');
    return true;
  };

  // ── WISHLIST SYNC (2026-09-29) ──
  // Rich: "there should also in mission control be the wishlist picks from
  // the customer". The list above lives in ONE browser. For a signed-in
  // customer it is now also kept on their account (metafield symh.wishlist)
  // through the pull-list App Proxy, so Mission Control can show it and the
  // phone and the laptop agree. First load on a device merges what the
  // browser already had into the account; after that the account copy is the
  // truth and every heart/unheart pushes the full list. Signed-out visitors
  // keep the browser-only list exactly as before — no request is made.
  // window.SYMH_CUSTOMER is set by layout/theme.liquid.
  var WL_SYNC_KEY = 'symh_wishlist_synced';
  function wlSignedIn() {
    return !!(window.SYMH_CUSTOMER && window.SYMH_CUSTOMER.signed_in);
  }
  function wlAdopt(handles) {
    if (!handles || Object.prototype.toString.call(handles) !== '[object Array]') return;
    if (JSON.stringify(handles) !== JSON.stringify(getWishlist())) {
      setWishlist(handles);
      refreshWishlistUI();
    }
    try { localStorage.setItem(WL_SYNC_KEY, '1'); } catch(e) {}
  }
  function wlPush(handles, op) {
    if (!wlSignedIn()) return;
    try {
      fetch('/apps/pull-list/wishlist', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(op === 'merge' ? { op: 'merge', handles: handles } : { handles: handles })
      }).then(function(r){ return r.json().catch(function(){ return {}; }); })
        .then(function(d){ if (d && d.ok) wlAdopt(d.handles); })
        .catch(function(){});
    } catch(e) {}
  }
  function initWishlistSync() {
    if (!wlSignedIn()) return;
    var synced = false;
    try { synced = localStorage.getItem(WL_SYNC_KEY) === '1'; } catch(e) {}
    var local = getWishlist();
    if (!synced && local.length) { wlPush(local, 'merge'); return; }
    fetch('/apps/pull-list/wishlist', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json().catch(function(){ return {}; }); })
      .then(function(d){ if (d && d.ok) wlAdopt(d.handles); })
      .catch(function(){});
  }
  function refreshWishlistUI() {
    var w = getWishlist();
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var h = btns[i].getAttribute('data-wishlist-toggle');
      btns[i].classList.toggle('is-saved', w.indexOf(h) >= 0);
    }
  }
  function updateWishCount() {
    var w = getWishlist();
    var el = document.getElementById('wish-count');
    if (el) {
      el.textContent = w.length;
      el.style.display = w.length > 0 ? 'flex' : 'none';
    }
  }

  // ── RECENTLY VIEWED ──
  function trackProductView() {
    var prod = document.querySelector('[data-product-handle-current]');
    if (!prod) return;
    var handle = prod.getAttribute('data-product-handle-current');
    if (!handle) return;
    // Internal-tagged products (deposit, advance-orders, etc.) never enter
    // recently-viewed. Marker set by templates/product.liquid at render time.
    if (prod.getAttribute('data-product-internal') === '1') return;
    try {
      var arr = JSON.parse(localStorage.getItem('symh_recent_viewed') || '[]');
      arr = arr.filter(function(x){ return x !== handle; });
      arr.unshift(handle);
      arr = arr.slice(0, 12);
      localStorage.setItem('symh_recent_viewed', JSON.stringify(arr));
    } catch(e){}
  }
  function renderRecentlyViewed() {
    var el = document.getElementById('recently-viewed');
    if (!el) return;
    var arr = [];
    try { arr = JSON.parse(localStorage.getItem('symh_recent_viewed') || '[]'); } catch(e){}
    var current = el.getAttribute('data-skip');
    arr = arr.filter(function(h){ return h !== current; }).slice(0, 8);
    if (arr.length === 0) { el.parentElement.style.display = 'none'; return; }
    // Fetch all in parallel and render in chronological order so cards don't
    // appear out of order due to varying network latencies.
    Promise.all(arr.map(function(handle){
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    })).then(function(products){
      var html = '';
      products.forEach(function(p){
        if (!p) return;
        // Skip any product whose tags contain 'internal:' — deposit +
        // reservation-plumbing products should never appear in a
        // customer-facing recently-viewed rail. Backstops trackProductView
        // for handles saved before the tracking-side filter landed.
        if (p.tags && p.tags.some(function(t){ return t.indexOf('internal:') !== -1; })) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        html += '<a href="' + escapeHTML(p.url || '#') + '" class="rv-item' + (p.available === false ? ' rv-item--soldout' : '') + '"><div class="rv-img">' +
          (img ? '<img src="' + escapeHTML(img) + '" alt="" loading="lazy">' : '') +
          '</div><div class="rv-title">' + escapeHTML(p.title || '') + '</div><div class="rv-price">' + money(p.price || 0) + '</div></a>';
      });
      el.innerHTML = html;
    });
  }


  // ── SLIDE ARROWS (flipbook, recently viewed, any horizontal scroller) ──
  // Uses event delegation so arrows work even after Shopify customizer re-renders a section.
  function initSlideArrows() {
    if (window._symhSlideDelegated) return; // ensure single delegation handler
    window._symhSlideDelegated = true;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest && e.target.closest('[data-slide-prev], [data-slide-next]');
      if (!btn) return;
      e.preventDefault();

      var dir = btn.hasAttribute('data-slide-next') ? 1 : -1;
      // Find track: prefer sibling within button's parent, then any ancestor with one
      var wrap = btn.parentElement;
      var track = wrap.querySelector('[data-slide-track]');
      if (!track) {
        var ancestor = btn.closest('[data-slide-section], .flipbook-wrap, .rv-wrap, .coll-rail__wrap');
        track = ancestor ? ancestor.querySelector('[data-slide-track]') : null;
      }
      if (!track) return;

      var firstCard = track.firstElementChild;
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth * 0.8;
      var gapStr = getComputedStyle(track).gap || getComputedStyle(track).columnGap || '24px';
      var gap = parseInt(gapStr, 10) || 24;
      var step = (cardWidth + gap) * 2;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });

    // Bind scroll-state listeners (hide arrows at boundaries)
    bindAllTrackScrollStates();
  }

  function bindAllTrackScrollStates() {
    var tracks = document.querySelectorAll('[data-slide-track]');
    for (var k = 0; k < tracks.length; k++) {
      if (!tracks[k]._symhScrollBound) {
        tracks[k]._symhScrollBound = true;
        bindTrackScrollState(tracks[k]);
      }
    }
  }
  function bindTrackScrollState(track) {
    var wrap = track.parentElement;
    var prevBtn = wrap.querySelector('[data-slide-prev]');
    var nextBtn = wrap.querySelector('[data-slide-next]');

    function updateArrows() {
      var atStart = track.scrollLeft <= 4;
      // Account for sub-pixel rounding at the right edge with a 2px tolerance
      var atEnd = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
      if (prevBtn) {
        prevBtn.disabled = atStart;
        prevBtn.removeAttribute('hidden'); // ensure legacy hidden attr is cleared
      }
      if (nextBtn) {
        nextBtn.disabled = atEnd;
        nextBtn.removeAttribute('hidden');
      }
    }
    updateArrows();
    track.addEventListener('scroll', function() {
      window.requestAnimationFrame(updateArrows);
    });
    // Update on resize too
    window.addEventListener('resize', updateArrows);
    // Update after content loads (recently-viewed populates async)
    var mo = new MutationObserver(updateArrows);
    mo.observe(track, { childList: true, subtree: false });
  }


  // ── STAT COUNTER (count up when scrolled into view) ──
  function initStatCounters() {
    var stats = document.querySelectorAll('.stat-num');
    if (!stats.length || !window.IntersectionObserver) return;
    var seen = new WeakSet();
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(en) {
        if (en.isIntersecting && !seen.has(en.target)) {
          seen.add(en.target);
          animateStat(en.target);
        }
      });
    }, { threshold: 0.5 });
    for (var i = 0; i < stats.length; i++) io.observe(stats[i]);
  }
  function animateStat(el) {
    var raw = el.textContent.trim();
    var match = raw.match(/^([^\d]*)(\d[\d,]*)([^\d]*)$/);
    if (!match) return;
    var prefix = match[1], num = match[2].replace(/,/g, ''), suffix = match[3];
    var target = parseInt(num, 10);
    if (isNaN(target)) return;
    var duration = 1100;
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var val = Math.round(target * eased);
      el.textContent = prefix + val.toLocaleString() + suffix;
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    }
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(tick);
  }

  // ── HERO mouse parallax ──
  function initHeroParallax() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    hero.addEventListener('mousemove', function(e) {
      var rect = hero.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      hero.style.setProperty('--mx', x + '%');
      hero.style.setProperty('--my', y + '%');
    });
    hero.addEventListener('mouseleave', function() {
      hero.style.setProperty('--mx', '50%');
      hero.style.setProperty('--my', '50%');
    });
  }

  // ── COMIC BURST on add-to-cart ──
  var burstWords = ['POW!', 'BAM!', 'ZAP!', 'WHAM!', 'BOOM!', 'KAPOW!', 'WHACK!', 'KRAK!'];
  function comicBurst(x, y) {
    var word = burstWords[Math.floor(Math.random() * burstWords.length)];
    var el = document.createElement('div');
    el.className = 'comic-burst';
    el.textContent = word;
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    document.body.appendChild(el);
    setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 900);
  }
  // Single source of truth: one document-level click listener catches every
  // Add-to-Cart button click and fires the burst at the actual click point.
  // Match by behavior, not class: any element whose inline onclick calls
  // SYMH.addToCart, plus the product page button (.atc-btn — no inline
  // onclick, uses an event listener), plus any custom [data-burst] hook.
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t.closest) return;
    var el = t.closest('[onclick*="SYMH.addToCart"]') ||
             t.closest('.atc-btn') ||
             t.closest('[data-burst]');
    if (el && !el.disabled) {
      comicBurst(e.clientX, e.clientY);
    }
  });


  // ── COLLECTION TABS — click handler ──
  function initCollTabs() {
    var sections = document.querySelectorAll('[data-coll-tabs]');
    for (var i = 0; i < sections.length; i++) {
      bindCollTabSection(sections[i]);
    }
  }
  function bindCollTabSection(sec) {
    var tabs = sec.querySelectorAll('.coll-tab');
    var panels = sec.querySelectorAll('.coll-tab-panel');
    for (var i = 0; i < tabs.length; i++) {
      (function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-tab-target');
          for (var j = 0; j < tabs.length; j++) {
            tabs[j].classList.remove('is-active');
            tabs[j].setAttribute('aria-selected', 'false');
          }
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          for (var k = 0; k < panels.length; k++) {
            panels[k].classList.toggle('is-active', panels[k].id === target);
          }
        });
      })(tabs[i]);
    }
  }



  // ── FAQ search + category filter ──
  function initFAQ() {
    var searchInputs = document.querySelectorAll('[data-faq-search]');
    var catContainers = document.querySelectorAll('[data-faq-categories]');
    var clearLinks = document.querySelectorAll('[data-faq-clear]');

    for (var i = 0; i < searchInputs.length; i++) {
      bindFaqSearch(searchInputs[i]);
    }
    for (var j = 0; j < catContainers.length; j++) {
      bindFaqCategories(catContainers[j]);
    }
    for (var k = 0; k < clearLinks.length; k++) {
      bindFaqClear(clearLinks[k]);
    }
  }

  function getFaqRoot(el) {
    return el.closest('.faq-section');
  }

  function bindFaqSearch(input) {
    input.addEventListener('input', function() {
      filterFAQ(getFaqRoot(input));
    });
  }
  function bindFaqCategories(container) {
    var chips = container.querySelectorAll('.faq-cat-chip');
    for (var i = 0; i < chips.length; i++) {
      (function(chip) {
        chip.addEventListener('click', function() {
          for (var j = 0; j < chips.length; j++) chips[j].classList.remove('is-active');
          chip.classList.add('is-active');
          filterFAQ(getFaqRoot(chip));
        });
      })(chips[i]);
    }
  }
  function bindFaqClear(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var root = getFaqRoot(link);
      if (!root) return;
      var input = root.querySelector('[data-faq-search]');
      var allChip = root.querySelector('[data-faq-cat="all"]');
      if (input) input.value = '';
      if (allChip) {
        var chips = root.querySelectorAll('.faq-cat-chip');
        for (var i = 0; i < chips.length; i++) chips[i].classList.remove('is-active');
        allChip.classList.add('is-active');
      }
      filterFAQ(root);
      if (input) input.focus();
    });
  }

  function filterFAQ(root) {
    if (!root) return;
    var searchInput = root.querySelector('[data-faq-search]');
    var activeChip = root.querySelector('.faq-cat-chip.is-active');
    var items = root.querySelectorAll('[data-faq-item]');
    var emptyState = root.querySelector('[data-faq-empty]');
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var category = activeChip ? activeChip.getAttribute('data-faq-cat') : 'all';
    var visibleCount = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var itemCat = item.getAttribute('data-faq-category') || '';
      var matchCat = category === 'all' || itemCat === category;
      var text = item.textContent.toLowerCase();
      var matchSearch = !query || text.indexOf(query) !== -1;
      var visible = matchCat && matchSearch;
      if (visible) {
        item.removeAttribute('data-faq-hidden');
        visibleCount++;
      } else {
        item.setAttribute('data-faq-hidden', 'true');
      }
    }

    if (emptyState) {
      emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  }


  // ── COLLECTION FILTER SIDEBAR ──
  function initCollectionFilters() {
    var toggles = document.querySelectorAll('[data-cf-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      (function(t) {
        t.addEventListener('click', function() {
          var expanded = t.getAttribute('aria-expanded') === 'true';
          t.setAttribute('aria-expanded', !expanded);
        });
      })(toggles[i]);
    }
    // Mobile drawer
    var openBtn = document.querySelector('[data-cf-open]');
    var closeBtn = document.querySelector('[data-cf-close]');
    var filters = document.getElementById('collection-filters');
    if (openBtn && filters) {
      // Lift drawer out of .container's stacking context on mobile only
      // (.container has z-index:1 which traps fixed children below the body-level overlay)
      var filtersHome = filters.parentNode;
      function liftIfMobile() {
        if (window.matchMedia('(max-width: 900px)').matches) {
          if (filters.parentElement !== document.body) document.body.appendChild(filters);
        } else {
          if (filters.parentElement !== filtersHome) filtersHome.appendChild(filters);
        }
      }
      liftIfMobile();
      window.addEventListener('resize', liftIfMobile);
      // Build overlay if not present
      var overlay = document.querySelector('.collection-filters-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'collection-filters-overlay';
        document.body.appendChild(overlay);
      }
      function openFilters() {
        filters.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        try { sessionStorage.setItem('symh_filters_open', '1'); } catch(e){}
      }
      function closeFilters() {
        filters.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        try { sessionStorage.removeItem('symh_filters_open'); } catch(e){}
      }

      openBtn.addEventListener('click', openFilters);
      if (closeBtn) closeBtn.addEventListener('click', closeFilters);
      overlay.addEventListener('click', closeFilters);

      // Escape key closes drawer
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && filters.classList.contains('is-open')) closeFilters();
      });

      // Persist open state across page reloads from filter selections
      var filterLinks = filters.querySelectorAll('.cf-option');
      for (var j = 0; j < filterLinks.length; j++) {
        filterLinks[j].addEventListener('click', function(){
          try { sessionStorage.setItem('symh_filters_open', '1'); } catch(e){}
        });
      }

      // On load, restore drawer state if mobile
      try {
        if (sessionStorage.getItem('symh_filters_open') === '1' &&
            window.matchMedia('(max-width: 900px)').matches) {
          openFilters();
        }
      } catch(e){}
    }
  }

  // Cmd/Ctrl+K opens search
  document.addEventListener('keydown', function(e) {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      if (window.SYMH && window.SYMH.openSearch) window.SYMH.openSearch();
    }
  });

  // Customizer hooks
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e){
      var els = (e.target || document).querySelectorAll('.reveal');
      for (var i = 0; i < els.length; i++) els[i].classList.add('in');
      var rotators = (e.target || document).querySelectorAll('[data-rotator]');
      for (var r = 0; r < rotators.length; r++) setupRotator(rotators[r]);
      var walls = (e.target || document).querySelectorAll('[data-fadewall]');
      for (var w = 0; w < walls.length; w++) setupFadeWall(walls[w]);
      initParticles();
    });
    document.addEventListener('shopify:section:select', function(e){
      var els = (e.target || document).querySelectorAll('.reveal');
      for (var i = 0; i < els.length; i++) els[i].classList.add('in');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
    // Re-bind track scroll states when Shopify re-renders a section in customizer
    document.addEventListener('shopify:section:load', function() {
      var tracks = document.querySelectorAll('[data-slide-track]');
      for (var k = 0; k < tracks.length; k++) {
        if (!tracks[k]._symhScrollBound) {
          tracks[k]._symhScrollBound = true;
          // Trigger native scroll event to recompute arrow visibility
          tracks[k].dispatchEvent(new Event('scroll'));
        }
      }
    });
  }
})();
